import {
  getSupport,
  sendSupport,
  getStreamActivity,
  getStreamActivityEventNames,
} from '../../api/player';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_PLAYER_VALUE = 'CHANGE_PLAYER_VALUE';
export const CHANGE_PLAYER_SEVERAL_VALUES = 'CHANGE_PLAYER_SEVERAL_VALUES';
export const CHANGE_PLAYER_STREAM_VALUE = 'CHANGE_PLAYER_STREAM_VALUE';
export const CHANGE_PLAYER_STREAM_SEVERAL_VALUES = 'CHANGE_PLAYER_STREAM_SEVERAL_VALUES';
export const CHANGE_PLAYER_STREAM_MODE = 'CHANGE_PLAYER_STREAM_MODE';
export const CHANGE_ACTIVITY_HISTORY_SEARCH = 'CHANGE_ACTIVITY_HISTORY_SEARCH';

export const SET_ACTIVE_STREAMS = 'SET_ACTIVE_STREAMS';
export const ADD_ACTIVE_STREAM = 'ADD_ACTIVE_STREAM';
export const REORDER_ACTIVE_STREAMS = 'REORDER_ACTIVE_STREAMS';
export const REMOVE_ACTIVE_STREAM = 'REMOVE_ACTIVE_STREAM';

export const GET_STREAM_ACTIVITY = 'GET_STREAM_ACTIVITY';
export const GET_STREAM_ACTIVITY_SUCCESS = 'GET_STREAM_ACTIVITY_SUCCESS';
export const GET_STREAM_ACTIVITY_ERROR = 'GET_STREAM_ACTIVITY_ERROR';
export const ADD_STREAM_ACTIVITY_EVENT = 'ADD_STREAM_ACTIVITY_EVENT';
export const ADD_STREAM_ACTIVITY_EVENTS = 'ADD_STREAM_ACTIVITY_EVENTS';
export const SET_STREAM_ACTIVITY_LOADING = 'SET_STREAM_ACTIVITY_LOADING';
export const RESET_STREAM_ACTIVITY = 'RESET_STREAM_ACTIVITY';

export const GET_SUPPORT = 'GET_SUPPORT';
export const GET_SUPPORT_RESULT = 'GET_SUPPORT_RESULT';
export const GET_SUPPORT_ERROR = 'GET_SUPPORT_ERROR';

export const NEW_SUPPORT = 'NEW_SUPPORT';
export const NEW_SUPPORT_RESULT = 'NEW_SUPPORT_RESULT';
export const NEW_SUPPORT_ERROR = 'NEW_SUPPORT_ERROR';

export const SEND_SUPPORT = 'SEND_SUPPORT';
export const SEND_SUPPORT_RESULT = 'SEND_SUPPORT_RESULT';
export const SEND_SUPPORT_ERROR = 'SEND_SUPPORT_ERROR';

export const ADD_SUPPORT_ATTACHMENT = 'ADD_SUPPORT_ATTACHMENT';
export const EDIT_SUPPORT_ATTACHMENT = 'EDIT_SUPPORT_ATTACHMENT';
export const DELETE_SUPPORT_ATTACHMENT = 'DELETE_SUPPORT_ATTACHMENT';

export const RESET_KITCHEN_PLAYER_STORE = 'RESET_KITCHEN_PLAYER_STORE';

export const addSupportAttachment = (file) => ({
  type: ADD_SUPPORT_ATTACHMENT,
  payload: { file },
});

export const editSupportAttachment = (id, key, value) => ({
  type: EDIT_SUPPORT_ATTACHMENT,
  payload: { id, key, value },
});

export const deleteSupportAttachment = (id) => ({
  type: DELETE_SUPPORT_ATTACHMENT,
  payload: { id },
});

export const changeValue = (key, value) => ({
  type: CHANGE_PLAYER_VALUE,
  payload: { key, value },
});

export const changeStreamValue = (key, value, streamId) => ({
  type: CHANGE_PLAYER_STREAM_VALUE,
  payload: { key, value, streamId },
});

export const changeStreamSeveralValues = (values, streamId) => ({
  type: CHANGE_PLAYER_STREAM_SEVERAL_VALUES,
  payload: { values, streamId },
});

export const changeStreamMode = (live, streamId) => ({
  type: CHANGE_PLAYER_STREAM_MODE,
  payload: { live, streamId },
});

export const setStreamActivityLoading = loading => ({
  type: SET_STREAM_ACTIVITY_LOADING,
  payload: loading,
});

export const resetStreamActivity = payload => ({
  type: RESET_STREAM_ACTIVITY,
  payload,
});

export const setActiveStreams = payload => ({
  type: SET_ACTIVE_STREAMS,
  payload,
});

export const addActiveStream = payload => ({
  type: ADD_ACTIVE_STREAM,
  payload,
});

export const reorderActiveStreams = payload => ({
  type: REORDER_ACTIVE_STREAMS,
  payload,
});

export const removeActiveStream = payload => ({
  type: REMOVE_ACTIVE_STREAM,
  payload,
});

export const changeActivityHistorySearch = search => ({
  type: CHANGE_ACTIVITY_HISTORY_SEARCH,
  payload: { search },
});

export const getSupportAction = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: GET_SUPPORT });
    try {
      const response = await getSupport(params);
      const { success, results } = response;
      if (success) {
        dispatch({ type: GET_SUPPORT_RESULT, payload: results });
        if (actions.onSuccess) {
          actions.onSuccess(results);
        }
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_SUPPORT_ERROR });
    }
  };
};

export const sendSupportAction = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: SEND_SUPPORT });
    try {
      const response = await sendSupport(params);
      const { success, results } = response;
      if (success) {
        dispatch({ type: SEND_SUPPORT_RESULT, payload: results });
        if (actions.onSuccess) {
          actions.onSuccess(results);
        }
      }
    } catch (error) {
      console.log(error);
      actions.onError(error && error.message ? error.message : 'Something went wrong');
      dispatch({ type: SEND_SUPPORT_ERROR });
    }
  };
};

export const getStreamActivityAction = (function () {
  let prevController;

  return ({ params, actions = {}, timezone }) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;

      dispatch({ type: GET_STREAM_ACTIVITY, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getStreamActivity(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          actions.onSuccess && actions.onSuccess(results.content);
          dispatch({ type: GET_STREAM_ACTIVITY_SUCCESS, payload: results, params: params, timezone });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          actions.onError && actions.onError(error.message);
          dispatch({ type: GET_STREAM_ACTIVITY_ERROR });
        }
      }
    };
  };
})();

export const getStreamActivityPollingAction = (function () {
  let prevController;
  
  return ({ params, actions = {}, timezone }) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      
      try {
        const response = await getStreamActivity(params, abortController.signal);
        const { success, results } = response;
        
        if (success && !abortController.signal.aborted) {
          if (actions.onSuccess) {
            actions.onSuccess(results.content);
          }
          
          dispatch({ type: ADD_STREAM_ACTIVITY_EVENTS, payload: results.content, timezone });
        }
      } catch (error) {}
    };
  };
})();

export const getStreamEventNamesAction = (params, actions = {}) => {
  return async () => {
    try {
      const response = await getStreamActivityEventNames(params);
      const { success, results } = response;
      if (success) {
        actions.onSuccess && actions.onSuccess(results);
      }
    } catch (error) {
      actions.onError && actions.onError(error.message);
      console.log(error);
    } finally {
      if (actions.onComplete) {
        actions.onComplete();
      }
    }
  };
};

export const addStreamActivityEvent = ({ event, timezone }) => ({
  type: ADD_STREAM_ACTIVITY_EVENT,
  payload: event,
  timezone,
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_PLAYER_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_KITCHEN_PLAYER_STORE,
});
